import { DownCaratIcon, useIconSize } from 'foundations-assets';
import { StyledDownCaratIconWrapper } from './Select.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownCarat = ({
  hasSelectedValues,
  clearable
}) => {
  const iconSize = useIconSize('100');
  if (clearable) {
    if (!hasSelectedValues) {
      return /*#__PURE__*/_jsx(StyledDownCaratIconWrapper, {
        $size: iconSize,
        children: /*#__PURE__*/_jsx(DownCaratIcon, {})
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(StyledDownCaratIconWrapper, {
    $size: iconSize,
    children: /*#__PURE__*/_jsx(DownCaratIcon, {})
  });
};